import Breadcrumbs, { BreadcrumbsProps } from '@material-ui/core/Breadcrumbs';
import React from 'react';
import StyledBreadcrumbHome from '../StyledBreadcrumbHome';

export interface AppBreadcrumbsProps extends BreadcrumbsProps<'div'> {
  children?: React.ReactNode;
  disableHome?: boolean;
}

const AppBreadcrumbs = React.forwardRef<HTMLDivElement, AppBreadcrumbsProps>(
  ({ children, disableHome, ...rest }, ref) => {
    return (
      <Breadcrumbs ref={ref} aria-label='breadcrumb' {...rest}>
        {!disableHome && <StyledBreadcrumbHome />}
        {children}
      </Breadcrumbs>
    );
  },
);

AppBreadcrumbs.displayName = 'AppBreadcrumbs';

export default AppBreadcrumbs;
